import React from 'react';
import { Link } from "react-router-dom";

import FundraisingHeader from "../layout/header";
import FundraisingFooter from '../layout/footer';

const OurFacility = () => {
    const features = [
        {
            id: 'autism-classrooms',
            title: 'Autism Classrooms',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19 10V7a7 7 0 0 0-14 0v3H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-1zm-2 0H7V7a5 5 0 0 1 10 0v3zM7 14a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm10 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z" />
                </svg>
            )
        },
        {
            id: 'infant-care',
            title: 'Infant & Early Childhood Care',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm0 10c-4.42 0-8 1.79-8 4v2h16v-2c0-2.21-3.58-4-8-4zm-6 2h2v2H6v-2z" />
                    <circle cx="18" cy="18" r="3" fill="none" stroke="currentColor" strokeWidth="2" />
                    <path d="M20 20l2 2" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
            )
        },
        {
            id: 'therapy-rooms',
            title: 'Therapy & Sensory Rooms',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                </svg>
            )
        },
        {
            id: 'parent-training',
            title: 'Parent Training & Family Support',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
                </svg>
            )
        },
        {
            id: 'staff-ops',
            title: 'Staff Operations & Administration',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z" />
                </svg>
            )
        },
    ];

    return (
        <>
            {/* Fix: Add scroll margin top so sticky header doesn't cover the cards */}
            <style>
                {`
                    .scroll-target {
                        scroll-margin-top: 160px;
                    }
                `}
            </style>

            <FundraisingHeader />
            <main className="overflow-hidden" style={{ marginTop: "-20px" }}>

                {/* ================= EDITORIAL HERO ================= */}
                <section className="position-relative overflow-hidden d-flex flex-column py-5" style={{ minHeight: '650px' }}>

                    {/* Background Image */}
                    <img
                        src="/assets/images/fundraising/Jonesboro-Grant County Community Center.png"
                        alt="Facility background"
                        className="position-absolute top-0 start-0 w-100 h-100"
                        style={{ objectFit: 'cover', objectPosition: 'center 65%', zIndex: 0 }}
                    />

                    {/* CHANGED: Dark Overlay instead of White */}
                    <div
                        className="position-absolute top-0 start-0 w-100 h-100"
                        style={{
                            background: 'linear-gradient(180deg, rgba(15,23,42,0.85) 0%, rgba(15,23,42,0.65) 50%, rgba(15,23,42,0.85) 100%)',
                            zIndex: 1,
                        }}
                    ></div>

                    {/* Centered Content */}
                    <div className="container position-relative flex-grow-1 d-flex flex-column align-items-center justify-content-center text-center" style={{ zIndex: 2, paddingTop: '3rem', paddingBottom: '4rem' }}>

                        {/* Main Headline - Changed text to white */}
                        <h1
                            className="fw-bold mb-3 mx-auto"
                            style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: 'clamp(2.5rem, 5vw, 4.5rem)', lineHeight: 1.1, color: '#ffffff', maxWidth: '800px' }}
                        >
                            A Facility Designed <br className="d-none d-lg-block" /> for <span style={{ color: '#f59e0b' }}>Possibilities.</span>
                        </h1>

                        {/* Subheadline - Changed text to a light gray */}
                        <p className="lh-lg mb-5 mx-auto" style={{ color: '#e2e8f0', fontSize: '1.15rem', maxWidth: '650px', fontWeight: 500 }}>
                            A state-of-the-art early childhood and special needs center where children of all abilities can learn, play, receive therapies, and build brighter futures.
                        </p>

                        {/* Button - Kept Dark Navy but added a border to stand out against dark bg */}
                        <Link to="/campaign-contact" className="text-decoration-none">
                            <button
                                className="btn fw-semibold rounded-pill px-4 py-3 d-inline-flex align-items-center gap-2"
                                style={{
                                    background: '#1e293b',
                                    color: '#ffffff',
                                    fontSize: '1.05rem',
                                    boxShadow: '0 10px 25px -5px rgba(0,0,0,0.5)',
                                    transition: 'transform 0.2s ease',
                                    border: '1px solid rgba(255,255,255,0.2)' // Added border for visibility
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-2px)')}
                                onMouseLeave={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
                            >
                                Explore the Vision
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12l-7.5 7.5M21 12H3" />
                                </svg>
                            </button>
                        </Link>
                    </div>

                    {/* Bottom Feature Strip - Kept mostly same but darkened text/icons for contrast against white strip */}
                    <div
                        className="w-100 position-absolute bottom-0 start-0"
                        style={{
                            zIndex: 3,
                            background: 'rgba(255, 255, 255, 0.9)', // Slightly more opaque
                            backdropFilter: 'blur(12px)',
                            WebkitBackdropFilter: 'blur(12px)',
                            borderTop: '1px solid rgba(255, 255, 255, 0.6)',
                            boxShadow: '0 -10px 30px -10px rgba(0,0,0,0.1)'
                        }}
                    >
                        <div className="container">
                            <div className="d-flex flex-nowrap justify-content-between align-items-center py-3 py-md-4">
                                {features.map((feature, idx) => (
                                    <a
                                        href={`#${feature.id}`}
                                        key={idx}
                                        className="text-decoration-none"
                                        style={{ flex: '1 1 0' }}
                                    >
                                        <div
                                            className="d-flex flex-column align-items-center text-center px-1 px-md-2 h-100"
                                            style={{ transition: 'transform 0.2s ease' }}
                                            onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-3px)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
                                        >
                                            <span className="mb-2 mb-md-3 text-dark">{feature.icon}</span>
                                            <p
                                                className="fw-bold mb-0"
                                                style={{
                                                    color: '#1e293b',
                                                    fontSize: '0.75rem',
                                                    lineHeight: '1.2'
                                                }}
                                            >
                                                {feature.title}
                                            </p>
                                        </div>
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>

                {/* ================= DETAILS SECTION ================= */}
                <section className="py-5" style={{ background: '#fdfaf4', paddingTop: '6rem', paddingBottom: '6rem' }}>
                    <div className="container">
                        <div className="row align-items-center g-5">

                            {/* Left Column (Image) */}
                            <div className="col-lg-6">
                                <div className="position-relative mx-auto" style={{ maxWidth: 500 }}>
                                    <div
                                        className="position-absolute w-100 h-100 rounded-4"
                                        style={{ background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)', transform: 'rotate(-3deg)', zIndex: 0, opacity: 0.8 }}
                                    ></div>
                                    <img
                                        src="/assets/images/founders-messag-img.jpg"
                                        alt="Inside our facility"
                                        className="position-relative img-fluid rounded-4 shadow-lg w-100"
                                        style={{ zIndex: 1, aspectRatio: '4/3', objectFit: 'cover' }}
                                    />
                                </div>
                            </div>

                            {/* Right Column (Text) */}
                            <div className="col-lg-6">
                                <span
                                    className="d-inline-flex align-items-center gap-2 rounded-pill fw-semibold mb-3"
                                    style={{
                                        background: 'rgba(251,191,36,0.12)',
                                        color: '#b45309',
                                        padding: '0.4rem 0.9rem',
                                        fontSize: '0.72rem',
                                        letterSpacing: '0.1em',
                                        textTransform: 'uppercase',
                                        border: '1px solid rgba(251,191,36,0.35)',
                                    }}
                                >
                                    <span className="d-inline-block rounded-circle" style={{ width: 6, height: 6, background: '#f59e0b' }}></span>
                                    Our Spaces
                                </span>

                                <h2
                                    className="fw-bold mb-4"
                                    style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: 'clamp(2rem, 3.5vw, 2.75rem)', lineHeight: 1.15, color: '#0f172a' }}
                                >
                                    A Welcoming Space for <span style={{ color: '#d97706' }}>Growth and Development</span>
                                </h2>

                                <p className="lh-lg mb-4" style={{ color: '#4b5563', fontSize: '1.05rem' }}>
                                    Our facility is designed to provide a welcoming, comfortable, and supportive environment for individuals, families, and professionals. Every space is thoughtfully planned to encourage collaboration, learning, and meaningful interactions.
                                </p>

                                <div
                                    className="p-4 rounded-4 mb-4 bg-white"
                                    style={{ boxShadow: '0 20px 40px -25px rgba(15,23,42,0.1)', borderLeft: '4px solid #f59e0b' }}
                                >
                                    <p className="mb-0 fst-italic fw-medium" style={{ color: '#0f172a', fontSize: '1.05rem' }}>
                                        "From dedicated activity areas to comfortable meeting spaces, our environment is built where people can connect, share ideas, and explore new opportunities."
                                    </p>
                                    <p className="mb-0 small text-muted mt-2">— The Just Generation Foundation</p>
                                </div>

                                <p className="lh-lg mb-0" style={{ color: '#4b5563', fontSize: '1.05rem' }}>
                                    We believe that a well-designed space can inspire creativity, build confidence, and support positive experiences. Our goal is to create an accessible and welcoming setting that reflects our commitment to quality, care, and community.
                                </p>
                            </div>

                        </div>
                    </div>
                </section>


                {/* ================= FACILITY FEATURES SECTION ================= */}
                <section className="py-5" style={{ background: '#ffffff' }}>
                    <div className="container py-lg-5">

                        <div className="text-center mx-auto mb-5" style={{ maxWidth: 750 }}>

                            <span
                                className="d-inline-flex align-items-center gap-2 rounded-pill fw-semibold mb-3"
                                style={{
                                    background: 'rgba(251,191,36,0.12)',
                                    color: '#b45309',
                                    padding: '0.4rem 0.9rem',
                                    fontSize: '0.72rem',
                                    letterSpacing: '0.1em',
                                    textTransform: 'uppercase',
                                    border: '1px solid rgba(251,191,36,0.35)',
                                }}
                            >
                                <span className="d-inline-block rounded-circle" style={{ width: 6, height: 6, background: '#f59e0b' }}></span>
                                OUR FACILITY
                            </span>

                            <h2
                                className="fw-bold mb-3"
                                style={{
                                    fontFamily: '"Playfair Display", Georgia, serif',
                                    fontSize: 'clamp(2rem, 3.5vw, 2.75rem)',
                                    color: '#0f172a'
                                }}
                            >
                                Spaces Designed for{' '}
                                <span style={{ color: '#d97706' }}>Every Possibility</span>
                            </h2>

                            <p className="lh-lg" style={{ color: '#64748b', fontSize: '1.05rem' }}>
                                Explore thoughtfully planned spaces that encourage learning,
                                development, family connections, and collaboration.
                            </p>
                        </div>

                        <div className="row g-4">

                            {/* Autism Classrooms */}
                            <div className="col-md-6 col-lg-4 scroll-target" id="autism-classrooms">
                                <div
                                    className="h-100 p-4 rounded-4"
                                    style={{ background: '#fdfaf4', border: '1px solid #f3e8d0', transition: 'all 0.3s ease', cursor: 'pointer' }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'scale(1.02)';
                                        e.currentTarget.style.boxShadow = '0 20px 40px -10px rgba(15,23,42,0.2)';
                                        e.currentTarget.style.background = '#1e293b';
                                        e.currentTarget.style.borderColor = '#1e293b';
                                        e.currentTarget.querySelector('h4').style.color = '#ffffff';
                                        e.currentTarget.querySelector('p').style.color = 'rgba(255,255,255,0.7)';
                                        e.currentTarget.querySelector('ul').style.color = 'rgba(255,255,255,0.7)';
                                        const iconWrap = e.currentTarget.querySelector('.icon-wrapper');
                                        iconWrap.style.background = 'rgba(255,255,255,0.1)';
                                        iconWrap.style.color = '#fbbf24';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'scale(1)';
                                        e.currentTarget.style.boxShadow = 'none';
                                        e.currentTarget.style.background = '#fdfaf4';
                                        e.currentTarget.style.borderColor = '#f3e8d0';
                                        e.currentTarget.querySelector('h4').style.color = '#1e293b';
                                        e.currentTarget.querySelector('p').style.color = '#64748b';
                                        e.currentTarget.querySelector('ul').style.color = '#475569';
                                        const iconWrap = e.currentTarget.querySelector('.icon-wrapper');
                                        iconWrap.style.background = '#fef3c7';
                                        iconWrap.style.color = '#b45309';
                                    }}
                                >
                                    <div className="icon-wrapper mb-4 rounded-3 d-flex align-items-center justify-content-center"
                                        style={{ width: 60, height: 60, background: '#fef3c7', color: '#b45309', transition: 'all 0.3s ease' }}>
                                        <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M19 10V7a7 7 0 0 0-14 0v3H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-1zm-2 0H7V7a5 5 0 0 1 10 0v3zM7 14a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm10 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z" />
                                        </svg>
                                    </div>
                                    <h4 className="fw-bold mb-3" style={{ color: '#1e293b', transition: 'color 0.3s ease' }}>
                                        Autism Classrooms
                                    </h4>
                                    <p className="lh-lg mb-4" style={{ color: '#64748b', fontSize: '0.95rem', transition: 'color 0.3s ease' }}>
                                        Welcoming and structured learning environments designed
                                        to encourage communication, creativity, confidence,
                                        and individual development at every child's pace.
                                    </p>
                                    <ul className="list-unstyled mb-0" style={{ color: '#475569', transition: 'color 0.3s ease' }}>
                                        <li className="mb-2">✓ Structured learning activities</li>
                                        <li className="mb-2">✓ Individual learning experiences</li>
                                        <li>✓ Supportive classroom environments</li>
                                    </ul>
                                </div>
                            </div>

                            {/* Infant & Early Childhood Care */}
                            <div className="col-md-6 col-lg-4 scroll-target" id="infant-care">
                                <div
                                    className="h-100 p-4 rounded-4"
                                    style={{ background: '#fdfaf4', border: '1px solid #f3e8d0', transition: 'all 0.3s ease', cursor: 'pointer' }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'scale(1.02)';
                                        e.currentTarget.style.boxShadow = '0 20px 40px -10px rgba(15,23,42,0.2)';
                                        e.currentTarget.style.background = '#1e293b';
                                        e.currentTarget.style.borderColor = '#1e293b';
                                        e.currentTarget.querySelector('h4').style.color = '#ffffff';
                                        e.currentTarget.querySelector('p').style.color = 'rgba(255,255,255,0.7)';
                                        e.currentTarget.querySelector('ul').style.color = 'rgba(255,255,255,0.7)';
                                        const iconWrap = e.currentTarget.querySelector('.icon-wrapper');
                                        iconWrap.style.background = 'rgba(255,255,255,0.1)';
                                        iconWrap.style.color = '#fbbf24';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'scale(1)';
                                        e.currentTarget.style.boxShadow = 'none';
                                        e.currentTarget.style.background = '#fdfaf4';
                                        e.currentTarget.style.borderColor = '#f3e8d0';
                                        e.currentTarget.querySelector('h4').style.color = '#1e293b';
                                        e.currentTarget.querySelector('p').style.color = '#64748b';
                                        e.currentTarget.querySelector('ul').style.color = '#475569';
                                        const iconWrap = e.currentTarget.querySelector('.icon-wrapper');
                                        iconWrap.style.background = '#fef3c7';
                                        iconWrap.style.color = '#b45309';
                                    }}
                                >
                                    <div className="icon-wrapper mb-4 rounded-3 d-flex align-items-center justify-content-center"
                                        style={{ width: 60, height: 60, background: '#fef3c7', color: '#b45309', transition: 'all 0.3s ease' }}>
                                        <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M12 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm0 10c-4.42 0-8 1.79-8 4v2h16v-2c0-2.21-3.58-4-8-4z" />
                                            <circle cx="18" cy="18" r="3" fill="none" stroke="currentColor" strokeWidth="2" />
                                        </svg>
                                    </div>
                                    <h4 className="fw-bold mb-3" style={{ color: '#1e293b', transition: 'color 0.3s ease' }}>
                                        Infant & Early Childhood Care
                                    </h4>
                                    <p className="lh-lg mb-4" style={{ color: '#64748b', fontSize: '0.95rem', transition: 'color 0.3s ease' }}>
                                        Nurturing spaces for young children where play,
                                        exploration, and early learning create opportunities
                                        to build curiosity, communication, and essential skills.
                                    </p>
                                    <ul className="list-unstyled mb-0" style={{ color: '#475569', transition: 'color 0.3s ease' }}>
                                        <li className="mb-2">✓ Age-appropriate activities</li>
                                        <li className="mb-2">✓ Play-based learning</li>
                                        <li>✓ Safe and caring surroundings</li>
                                    </ul>
                                </div>
                            </div>

                            {/* Therapy & Sensory Rooms */}
                            <div className="col-md-6 col-lg-4 scroll-target" id="therapy-rooms">
                                <div
                                    className="h-100 p-4 rounded-4"
                                    style={{ background: '#fdfaf4', border: '1px solid #f3e8d0', transition: 'all 0.3s ease', cursor: 'pointer' }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'scale(1.02)';
                                        e.currentTarget.style.boxShadow = '0 20px 40px -10px rgba(15,23,42,0.2)';
                                        e.currentTarget.style.background = '#1e293b';
                                        e.currentTarget.style.borderColor = '#1e293b';
                                        e.currentTarget.querySelector('h4').style.color = '#ffffff';
                                        e.currentTarget.querySelector('p').style.color = 'rgba(255,255,255,0.7)';
                                        e.currentTarget.querySelector('ul').style.color = 'rgba(255,255,255,0.7)';
                                        const iconWrap = e.currentTarget.querySelector('.icon-wrapper');
                                        iconWrap.style.background = 'rgba(255,255,255,0.1)';
                                        iconWrap.style.color = '#fbbf24';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'scale(1)';
                                        e.currentTarget.style.boxShadow = 'none';
                                        e.currentTarget.style.background = '#fdfaf4';
                                        e.currentTarget.style.borderColor = '#f3e8d0';
                                        e.currentTarget.querySelector('h4').style.color = '#1e293b';
                                        e.currentTarget.querySelector('p').style.color = '#64748b';
                                        e.currentTarget.querySelector('ul').style.color = '#475569';
                                        const iconWrap = e.currentTarget.querySelector('.icon-wrapper');
                                        iconWrap.style.background = '#fef3c7';
                                        iconWrap.style.color = '#b45309';
                                    }}
                                >
                                    <div className="icon-wrapper mb-4 rounded-3 d-flex align-items-center justify-content-center"
                                        style={{ width: 60, height: 60, background: '#fef3c7', color: '#b45309', transition: 'all 0.3s ease' }}>
                                        <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
                                        </svg>
                                    </div>
                                    <h4 className="fw-bold mb-3" style={{ color: '#1e293b', transition: 'color 0.3s ease' }}>
                                        Therapy & Sensory Rooms
                                    </h4>
                                    <p className="lh-lg mb-4" style={{ color: '#64748b', fontSize: '0.95rem', transition: 'color 0.3s ease' }}>
                                        Dedicated environments for sensory exploration,
                                        therapeutic activities, and relaxation, helping
                                        children engage with their surroundings comfortably.
                                    </p>
                                    <ul className="list-unstyled mb-0" style={{ color: '#475569', transition: 'color 0.3s ease' }}>
                                        <li className="mb-2">✓ Sensory exploration areas</li>
                                        <li className="mb-2">✓ Calm and comfortable spaces</li>
                                        <li>✓ Guided therapeutic activities</li>
                                    </ul>
                                </div>
                            </div>

                            {/* Parent Training & Family Support */}
                            <div className="col-md-6 scroll-target" id="parent-training">
                                <div
                                    className="h-100 p-4 p-lg-5 rounded-4"
                                    style={{ background: '#fdfaf4', border: '1px solid #f3e8d0', transition: 'all 0.3s ease', cursor: 'pointer' }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'scale(1.02)';
                                        e.currentTarget.style.boxShadow = '0 20px 40px -10px rgba(15,23,42,0.2)';
                                        e.currentTarget.style.background = '#1e293b';
                                        e.currentTarget.style.borderColor = '#1e293b';
                                        e.currentTarget.querySelector('h4').style.color = '#ffffff';
                                        e.currentTarget.querySelector('p').style.color = 'rgba(255,255,255,0.7)';
                                        e.currentTarget.querySelector('ul').style.color = 'rgba(255,255,255,0.7)';
                                        const iconWrap = e.currentTarget.querySelector('.icon-wrapper');
                                        iconWrap.style.background = 'rgba(255,255,255,0.1)';
                                        iconWrap.style.color = '#fbbf24';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'scale(1)';
                                        e.currentTarget.style.boxShadow = 'none';
                                        e.currentTarget.style.background = '#fdfaf4';
                                        e.currentTarget.style.borderColor = '#f3e8d0';
                                        e.currentTarget.querySelector('h4').style.color = '#1e293b';
                                        e.currentTarget.querySelector('p').style.color = '#64748b';
                                        e.currentTarget.querySelector('ul').style.color = '#475569';
                                        const iconWrap = e.currentTarget.querySelector('.icon-wrapper');
                                        iconWrap.style.background = '#fef3c7';
                                        iconWrap.style.color = '#b45309';
                                    }}
                                >
                                    <div className="icon-wrapper mb-4 rounded-3 d-flex align-items-center justify-content-center"
                                        style={{ width: 60, height: 60, background: '#fef3c7', color: '#b45309', transition: 'all 0.3s ease' }}>
                                        <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5z" />
                                        </svg>
                                    </div>
                                    <h4 className="fw-bold mb-3" style={{ color: '#1e293b', transition: 'color 0.3s ease' }}>
                                        Parent Training & Family Support
                                    </h4>
                                    <p className="lh-lg mb-4" style={{ color: '#64748b', fontSize: '0.95rem', transition: 'color 0.3s ease' }}>
                                        Family-focused spaces that encourage parents and
                                        caregivers to learn, share experiences, access useful
                                        resources, and work together to support children's growth.
                                    </p>
                                    <ul className="list-unstyled mb-0" style={{ color: '#475569', transition: 'color 0.3s ease' }}>
                                        <li className="mb-2">✓ Parent education sessions</li>
                                        <li className="mb-2">✓ Family guidance and resources</li>
                                        <li>✓ Collaborative support meetings</li>
                                    </ul>
                                </div>
                            </div>

                            {/* Staff Operations & Administration */}
                            <div className="col-md-6 scroll-target" id="staff-ops">
                                <div
                                    className="h-100 p-4 p-lg-5 rounded-4"
                                    style={{ background: '#fdfaf4', border: '1px solid #f3e8d0', transition: 'all 0.3s ease', cursor: 'pointer' }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'scale(1.02)';
                                        e.currentTarget.style.boxShadow = '0 20px 40px -10px rgba(15,23,42,0.2)';
                                        e.currentTarget.style.background = '#1e293b';
                                        e.currentTarget.style.borderColor = '#1e293b';
                                        e.currentTarget.querySelector('h4').style.color = '#ffffff';
                                        e.currentTarget.querySelector('p').style.color = 'rgba(255,255,255,0.7)';
                                        e.currentTarget.querySelector('ul').style.color = 'rgba(255,255,255,0.7)';
                                        const iconWrap = e.currentTarget.querySelector('.icon-wrapper');
                                        iconWrap.style.background = 'rgba(255,255,255,0.1)';
                                        iconWrap.style.color = '#fbbf24';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'scale(1)';
                                        e.currentTarget.style.boxShadow = 'none';
                                        e.currentTarget.style.background = '#fdfaf4';
                                        e.currentTarget.style.borderColor = '#f3e8d0';
                                        e.currentTarget.querySelector('h4').style.color = '#1e293b';
                                        e.currentTarget.querySelector('p').style.color = '#64748b';
                                        e.currentTarget.querySelector('ul').style.color = '#475569';
                                        const iconWrap = e.currentTarget.querySelector('.icon-wrapper');
                                        iconWrap.style.background = '#fef3c7';
                                        iconWrap.style.color = '#b45309';
                                    }}
                                >
                                    <div className="icon-wrapper mb-4 rounded-3 d-flex align-items-center justify-content-center"
                                        style={{ width: 60, height: 60, background: '#fef3c7', color: '#b45309', transition: 'all 0.3s ease' }}>
                                        <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z" />
                                        </svg>
                                    </div>
                                    <h4 className="fw-bold mb-3" style={{ color: '#1e293b', transition: 'color 0.3s ease' }}>
                                        Staff Operations & Administration
                                    </h4>
                                    <p className="lh-lg mb-4" style={{ color: '#64748b', fontSize: '0.95rem', transition: 'color 0.3s ease' }}>
                                        Organized administrative and staff spaces that
                                        support communication, planning, teamwork, and the
                                        coordination of everyday facility activities.
                                    </p>
                                    <ul className="list-unstyled mb-0" style={{ color: '#475569', transition: 'color 0.3s ease' }}>
                                        <li className="mb-2">✓ Staff collaboration areas</li>
                                        <li className="mb-2">✓ Administrative workspaces</li>
                                        <li>✓ Planning and coordination</li>
                                    </ul>
                                </div>
                            </div>

                        </div>

                    </div>
                </section>

                {/* ================= BOTTOM CTA (Warm & Elegant) ================= */}
                <section className="py-5" style={{ background: '#fdfaf4', paddingTop: '6rem', paddingBottom: '6rem' }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <div
                                    className="rounded-4 text-center p-5 position-relative overflow-hidden text-white shadow-lg"
                                    style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)' }}
                                >
                                    <div className="position-absolute d-none d-md-block" style={{ width: '55%', height: '100%', top: 0, right: 0, background: 'radial-gradient(circle at 70% 50%, rgba(251,191,36,0.28) 0%, transparent 65%)' }}></div>

                                    <div className="position-relative">
                                        <span
                                            className="d-inline-flex align-items-center gap-2 rounded-pill fw-semibold mb-4"
                                            style={{ background: 'rgba(251,191,36,0.15)', color: '#fcd34d', padding: '0.4rem 0.9rem', fontSize: '0.72rem', letterSpacing: '0.1em', textTransform: 'uppercase', border: '1px solid rgba(251,191,36,0.35)' }}
                                        >
                                            <span className="d-inline-block rounded-circle" style={{ width: 6, height: 6, background: '#fbbf24' }}></span>
                                            Visit Us
                                        </span>

                                        <h3
                                            className="fw-bold mb-4"
                                            style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: 'clamp(1.9rem, 3.2vw, 2.75rem)', lineHeight: 1.15, letterSpacing: '-0.015em' }}
                                        >
                                            Ready to see the space <span style={{ color: '#fbbf24' }}>for yourself?</span>.
                                        </h3>

                                        <p className="lh-lg mb-5 mx-auto" style={{ color: 'rgba(255,255,255,0.75)', maxWidth: 640, fontSize: '1.05rem' }}>
                                            We'd love to welcome you. Reach out to schedule a visit or learn more about how our facility can support your unique needs.
                                        </p>

                                        <div className="d-flex flex-column flex-sm-row justify-content-center gap-3 mb-5">
                                            <Link to="/campaign-contact" className="text-decoration-none">
                                                <button
                                                    className="btn fw-bold rounded-pill d-inline-flex align-items-center gap-2 border-0"
                                                    style={{ background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)', color: '#1f2937', padding: '1rem 2rem', boxShadow: '0 15px 35px -12px rgba(251,191,36,0.7)' }}
                                                >
                                                    Get in Touch
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12l-7.5 7.5M21 12H3" />
                                                    </svg>
                                                </button>
                                            </Link>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <FundraisingFooter />
        </>
    );
};

export default OurFacility;